<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年05月12日 16:38:29 +0800
 * @最后修改时间: 2021-11-17 16:45:32
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Shift\ShiftList\components\newCriteriaTypeDialog.vue
 -->
<template>
  <normalDialog
    width="680"
    maxWidth="680"
    @close="closePorpertyDialog"
    :title="
      $t('label_essweb_punchCriteriaType_list_dialog_newCriteriaTypeTitle')
    "
    :dialog="show"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              isRequired
              label="label_essweb_shift_form_dialog_criteriaTypeLabel"
              :items="CriteriaType"
              v-model="curTypeuuid"
              :rules="$GetRules(['_Require_Rules'], [null])"
              item-text="criteria_type_name"
              item-value="uuid"
            >
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" v-if="false">
            <AutoComplete
              label="label_essweb_shift_form_dialog_siteNameLabel"
              :items="SiteList"
              v-model="curSiteuuid"
              disabled
              :rules="$GetRules(['_Require_Rules'], [null])"
              item-text="site_name"
              item-value="uuid"
            >
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              isRequired
              label="label_essweb_shift_form_dialog_criteriaNameLabel"
              :items="CriteriaName"
              v-model="curCriteriauuid"
              :append-icon="curTypeuuid ? 'arrow_drop_down' : ''"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :disabled="curTypeuuid ? false : true"
              :item-text="
                criteriaCode == 'FACE'
                  ? 'criteria_facial_name'
                  : criteriaCode == 'GPS'
                  ? 'criteria_gps_name'
                  : criteriaCode == 'WIFI'
                  ? 'criteria_wifi_name'
                  : criteriaCode == 'BLUETOOTH'
                  ? 'criteria_bluetooth_name'
                  : ''
              "
              item-value="uuid"
            >
            </AutoComplete>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions newBtn @new="newProperty" @cancel="closePorpertyDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newCriteriaType",
  props: ["show", "site"],
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
    criteriaCode() {
      if (this.curData.curType) {
        return this.curData.curType.punch_code;
      } else {
        return null;
      }
    },
    CriteriaType() {
      return this.$getSelectTrans(this.CriteriaTypeData, "criteria_type_name");
    },
    CriteriaName() {
      if (this.criteriaCode == "FACE")
        return this.$getSelectTrans(
          this.CriteriaNameData,
          "criteria_facial_name"
        );
      if (this.criteriaCode == "GPS")
        return this.$getSelectTrans(this.CriteriaNameData, "criteria_gps_name");
      if (this.criteriaCode == "WIFI")
        return this.$getSelectTrans(
          this.CriteriaNameData,
          "criteria_wifi_name"
        );
      if (this.criteriaCode == "BLUETOOTH")
        return this.$getSelectTrans(
          this.CriteriaNameData,
          "criteria_bluetooth_name"
        );
    },
  },
  data() {
    return {
      SiteList: [],
      CriteriaTypeData: [],
      CriteriaNameData: [],
      curData: {
        curCriteria: null,
        curType: null,
        curSite: null,
      },
      curCriteriauuid: null,
      curTypeuuid: null,
      curSiteuuid: null,
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.curCriteriauuid = null;
        this.curTypeuuid = null;
      }
    },
    site(val) {
      this.curSiteuuid = val;
    },
    criteriaCode(val) {
      this.curCriteriauuid = null;
      this.curData.curCriteria = null;
      // if (val) this.getCriteriaName(val);
    },
    curCriteriauuid(val) {
      if (val)
        this.curData.curCriteria = this.CriteriaNameData.filter(
          (ele) => ele.uuid === val
        )[0];
    },
    curTypeuuid(val) {
      if (val) {
        this.curData.curType = this.CriteriaTypeData.filter(
          (ele) => ele.uuid === val
        )[0];
        this.CriteriaNameData = this.curData.curType.criterias;
      }
    },
    curSiteuuid(val) {
      if (val) {
        this.curData.curSite = this.SiteList.filter(
          (ele) => ele.uuid === val
        )[0];
        this.getCriteriaType();
      }
    },
  },
  mounted() {
    this.getSiteList();
  },
  methods: {
    getCriteriaType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_map_punch_criteria_site",
        url: "/condition-mapping/get-condition-mapping-list/",
        data: {
          site_uuid: this.curSiteuuid,
          searchType: "common",
        },
      }).then((res) => {
        that.CriteriaTypeData = res.data;
      });
    },
    getCriteriaName: function (code) {
      const that = this;
      var data = null,
        url = "",
        table = "";
      switch (code) {
        case "FACE":
          url = "/facial-criteria/get-facial-criteria-list/";
          table = "ess_punch_criteria_facial_recognition";
          break;
        case "GPS":
          url = "/gps-criteria/get-gps-criteria-list/";
          table = "ess_punch_criteria_gps";
          break;
        case "WIFI":
          url = "/wifi-criteria/get-wifi-criteria-list/";
          table = "ess_punch_criteria_wifi";
          break;
        case "BLUETOOTH":
          url = "/bluetooth-criteria/get-bluetooth-criteria-list/";
          table = "ess_punch_criteria_bluetooth";
          break;
        default:
          break;
      }
      this.$Request({
        method: "POST",
        table: table,
        url: url,
        data: {},
      }).then((res) => {
        that.CriteriaNameData = res.data;
      });
    },
    getSiteList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_site",
        url: "/site/get-site-list/",
        data: {},
      }).then((res) => {
        res.data.map((item) => {
          item.site_name = that.$getCommonLangValue(item.site_name);
        });
        that.SiteList = res.data;
      });
    },
    closePorpertyDialog: function () {
      this.$emit("close", false);
    },
    newProperty: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("new", this.site, this.curData);
    },
  },
};
</script>
